import { DEFAULT_FIELD_NAMES } from '@/app/pages/Streams/field-utils'

/**
 * The columns the backend injects into every stream. They hold bookkeeping rather than device data,
 * so filters and free-text search exclude them (the endpoints answer a filter on one with a 400
 * "invalid column"), and so does RBAC — the stream-access editor refuses to scope them, so nothing
 * may demand a grant for one either.
 */
export const SYSTEM_COLUMNS: ReadonlySet<string> = new Set(DEFAULT_FIELD_NAMES)

export const isSystemColumn = (columnName: string): boolean => SYSTEM_COLUMNS.has(columnName.toLowerCase())

/** `date` is ClickHouse's partitioning column; `timestamp` carries the same instant with its time. */
const NON_EXPORTABLE_COLUMNS: ReadonlySet<string> = new Set(['date'])

export const isExportableColumn = (columnName: string): boolean => !NON_EXPORTABLE_COLUMNS.has(columnName.toLowerCase())

export const NON_EXPORTABLE_COLUMN_REASON =
	"This column is used internally for indexing and cannot be exported directly. Please select 'timestamp' to export date and time details instead."
